module.exports = __webpack_public_path__ + "static/media/pa.0d16b0e8.svg";